import { TmComponentError } from '@/core/error/TmComponentError'

interface FieldInputElement {
  blur(): void
  focus(): void
}

export const useFieldInputRefActions = (getEl: () => FieldInputElement | undefined) => {
  const focus = () => {
    if (!getEl()) {
      throw new TmComponentError('Input ref is undefined')
    }
    getEl()!.focus()
  }

  const blur = () => {
    if (!getEl()) {
      throw new TmComponentError('Input ref is undefined')
    }
    getEl()!.blur()
  }

  return {
    focus,
    blur,
  }
}
